import type { ResultTab } from '@/types/models';

/**
 * Standard result tabs used across all model types
 * Each model uses these same tabs for consistent UX
 */
export const standardResultTabs: ResultTab[] = [
  { id: 'revenue', label: 'Revenue', icon: '💰' },
  { id: 'charts', label: 'Charts', icon: '📊' },
  { id: 'pnl', label: 'P&L Statement', icon: '📈' },
  { id: 'cashflow', label: 'Cash Flow', icon: '💵' },
  { id: 'balance', label: 'Balance Sheet', icon: '⚖️' },
  { id: 'metrics', label: 'Key Metrics', icon: '🎯' },
  { id: 'valuation', label: 'Valuation', icon: '🏆' },
  { id: 'scenario', label: 'Scenarios', icon: '🔮' },
];
